/**
 * Form UI stores name, value and name_code as an object for a single input field.
 * API expects an array of additional item property entries.
 */
export const toFormAdditionalItemProperties = (value) => {
    if (!value) {
        return {  attribute_name: "", attribute_value: "", name_code: ""  };
    }

    if (Array.isArray(value)) {
        const withNameCode = value.find((entry) => entry?.name_code);

        return { attribute_name: withNameCode?.name, attribute_value: withNameCode?.value, name_code: withNameCode?.name_code ?? '' };
    }

    return {
        attribute_name: value.name ?? '',
        attribute_value: value.value ?? '',
        name_code: value.name_code ?? '',
    };
};

export const toApiAdditionalItemProperties = (values) => {
    if (!values) {
        return null;
    }

    if (Array.isArray(values)) {
        return values.length > 0 ? values : null;
    }

    const name = values.attribute_name;
    const value = values.attribute_value;
    const nameCode = values.name_code;

    if (nameCode === null || nameCode === undefined || String(nameCode).trim() === '') {
        return null;
    }

    return [{ name: String(name), value: String(value), name_code: String(nameCode) }];
};
